<template>
    <o-table :title="$t('sandoz.managed_kick_outs')" ref="tableList" url="/api/sandoz/wholesaler_kickout_match"
             :enable-new="false">
        <template slot="filter">
            <div class="row">
                <div class="col">
                    <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                        <o-filter-text :title="$t('sandoz.whs_customer_localkey')"
                                       column="whs_customer_localkey"></o-filter-text>
                        <o-filter-text :title="$t('sandoz.ean')" column="ean"></o-filter-text>
                    </o-filter>
                </div>
                <div class="col text-right" style="flex: 0 0 450px;">
                    <router-link :to="{ path: $route.path + '/ignores'}" class="btn btn-danger">
                      {{ $t('sandoz.ignores') }}
                    </router-link>
                    <o-button @click="excelReport" :loading="loading">
                        {{ $t('sandoz.download') }}
                    </o-button>
                    <router-link :to="{ path: $route.path + '/from_unmanaged_report'}" class="btn btn-primary">
                        {{ $t('sandoz.new_from_unmanaged_report') }}
                    </router-link>
                    <router-link :to="{ path: $route.path + '/from_blacklist_report'}" class="btn btn-primary">
                        {{ $t('sandoz.new_from_blacklist_report') }}
                    </router-link>
                </div>
            </div>
        </template>
        <template slot="head">
            <o-table-header column="whs_customer_localkey" style="background:#f9f9e8;">
                {{ $t('sandoz.whs_customer_localkey') }}
            </o-table-header>
            <o-table-header :sortable="false" style="background:#f9f9e8;">{{ $t('sandoz.whs_customer_name') }}
            </o-table-header>
            <o-table-header :sortable="false" style="background:#f9f9e8;">{{ $t('sandoz.whs_address') }}
            </o-table-header>
            <o-table-header :sortable="false" style="background:#f9f9e8;">{{ $t('sandoz.whs_zip') }}</o-table-header>
            <o-table-header column="ean" style="background:#cdffc3;">{{ $t('sandoz.mst_ean') }}</o-table-header>
            <o-table-header :sortable="false" style="background:#cdffc3;">{{ $t('sandoz.mst_customer_name') }}
            </o-table-header>
            <o-table-header :sortable="false" style="background:#cdffc3;">{{ $t('sandoz.mst_customer_address') }}
            </o-table-header>
            <o-table-header :sortable="false" style="background:#cdffc3;">{{ $t('sandoz.mst_customer_zip') }}
            </o-table-header>
            <o-table-header column="valid_from">{{ $t('sandoz.valid_from') }}</o-table-header>
            <o-table-header column="valid_to">{{ $t('sandoz.valid_to') }}</o-table-header>
            <o-table-header column="comment">{{ $t('sandoz.comment') }}</o-table-header>
            <o-table-header column="created_at">{{ $t('sandoz.created_at') }}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td style="background:#f9f9e8;"><o-text-preview>{{ props.item.whs_customer_localkey }}</o-text-preview></td>
            <td style="background:#f9f9e8;">{{ props.item.localkey_name }}</td>
            <td style="background:#f9f9e8;">{{ props.item.localkey_address }}</td>
            <td style="background:#f9f9e8;">{{ props.item.localkey_zip }}</td>
            <td style="background:#cdffc3;">{{ props.item.ean }}</td>
            <td style="background:#cdffc3;">{{ props.item.ean_customer }}</td>
            <td style="background:#cdffc3;">{{ props.item.ean_address }}</td>
            <td style="background:#cdffc3;">{{ props.item.ean_zip }}</td>
            <td>{{ props.item.valid_from | formatMonth }}</td>
            <td>{{ props.item.valid_to | formatMonth }}</td>
            <td v-text="props.item.comment"></td>
            <td>{{ props.item.created_at | formatDate }}</td>
        </template>
    </o-table>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
        loading: false
    }),
    methods: {
        excelReport() {
            const headers = {
                'accept': 'application/vnd.ms-excel'
            }

            this.loading = true

            axios({
                method: 'GET',
                url: '/api/sandoz/wholesaler_kickout_match/excel',
                responseType: 'blob',
                headers: headers
            }).then((response) => {
                var filename = 'report.xlsx'
                var contentDisposition = response.headers['content-disposition']
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
                    var matches = filenameRegex.exec(contentDisposition)
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '')
                    }
                }

                require('downloadjs')(response.data, filename, headers.accept)
                this.loading = false
            })
            .catch((err) => {
                this.$notify({
                    title: this.$i18n.t('core.error'),
                    text: this.$i18n.t('core.error_text', {error: err}),
                    type: 'error'
                })

                this.loading = false
            })
        }
    }
}
</script>

